import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SharedService } from 'src/app/services/shared.service';
import { RestaurantService } from '../../../services/restaurant.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

export interface NavItem {
  label: string;
  icon: string;
  id?: string;
  route?: string;
  liveOrdersBadge?: boolean;
  children?: NavItem[];
}

@Component({
  selector: 'app-main-sidebar',
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.scss']
})
export class MainSidebarComponent implements OnInit {
  totalOrders: any;
  restaurant: any;
  restaurant_id: any;
  user: any;
  tamplate_setting: any;
  openGroups: { [key: string]: boolean } = {};

  adminNavItems: NavItem[] = [
    { label: 'Dashboard', icon: 'fas fa-chart-area', route: '/admin/dashboard' },
    {
      label: 'Restaurants', icon: 'fas fa-mug-hot', id: 'admin-restaurants',
      children: [
        { label: 'All Restaurants', icon: 'far fa-list-alt', route: '/admin/restaurants' },
        { label: 'Add Restaurant', icon: 'fas fa-plus', route: '/admin/new-restaurant' }
      ]
    },
    { label: 'Live Orders', icon: 'fas fa-shopping-basket', route: '/admin/order-monitoring', liveOrdersBadge: true },
    { label: 'Reservations', icon: 'far fa-calendar-check', route: '/admin/reservation' },
    { label: 'Restaurant Health', icon: 'fas fa-heartbeat', route: '/admin/restaurant-health' },
    { label: 'Restaurant synopsis', icon: 'fas fa-chart-pie', route: '/admin/restaurant-synopsis' },
    {
      label: 'Users', icon: 'fas fa-users', id: 'admin-users',
      children: [
        { label: 'All Users', icon: 'fas fa-user-check', route: '/admin/user-tracking' },
        { label: 'Blocked Users', icon: 'fas fa-user-alt-slash', route: '/admin/user-blocklist' },
        { label: 'Activity Logs', icon: 'fas fa-history', route: '/admin/user-activities' }
      ]
    },
    {
      label: 'Staff Management', icon: 'fas fa-user-cog', id: 'admin-staff',
      children: [
        { label: 'System Staff', icon: 'fas fa-user-shield', route: '/admin/system-admin-users' },
        { label: 'Chain Management', icon: 'fas fa-code-branch', route: '/admin/chain-management' },
        { label: 'Staff Activity Logs', icon: 'fas fa-history', route: '/admin/system-user-activities' }
      ]
    },
    {
      label: 'Credentials', icon: 'fas fa-key', id: 'admin-credentials',
      children: [
        { label: 'Platform Credentials', icon: 'fas fa-user-shield', route: '/admin/user/platform-credentials' },
        { label: 'Stripe Credentials', icon: 'fab fa-stripe-s', route: '/admin/admin-stripe-accounts' }
      ]
    },
    {
      label: 'Marketing', icon: 'fas fa-bullhorn', id: 'admin-marketing',
      children: [
        { label: 'SMS Packages', icon: 'fas fa-sms', route: '/admin/marketing/sms-package' },
        { label: 'SMS Campaigns', icon: 'fas fa-comment-dots', route: '/admin/marketing/sms-marketing' },
        { label: 'Email Campaigns', icon: 'far fa-envelope', route: '/admin/marketing/email-marketing' },
        { label: 'Other Marketing', icon: 'fas fa-chart-pie', route: '/admin/marketing/othrs-marketing' }
      ]
    },
    {
      label: 'Billing & Invoices', icon: 'fas fa-file-invoice-dollar', id: 'admin-billing',
      children: [
        { label: 'Sales Report', icon: 'fas fa-chart-bar', route: '/admin/billing/sales-report' },
        { label: 'Transactions', icon: 'far fa-handshake', route: '/admin/billing/transaction' },
        { label: 'Transaction Summary', icon: 'fas fa-chart-pie', route: '/admin/billing/transaction-summary' }
      ]
    },
    { label: 'System Logs', icon: 'fas fa-clipboard-list', route: '/admin/admin-system-logs' }
  ];

  restaurantNavItems: NavItem[] = [
    { label: 'Dashboard', icon: 'fas fa-tachometer-alt', route: '/restaurant/dashboard' },
    {
      label: 'Orders & Activity', icon: 'fas fa-clipboard-list', id: 'res-orders',
      children: [
        { label: 'Live Orders', icon: 'fas fa-shopping-cart', route: '/restaurant/monitoring/order' },
        { label: 'Reservations', icon: 'far fa-calendar-check', route: '/restaurant/monitoring/reservation' },
        { label: 'Customer Reviews', icon: 'fas fa-star', route: '/restaurant/monitoring/review' }
      ]
    },
    {
      label: 'Menu', icon: 'fas fa-utensils', id: 'res-menu',
      children: [
        { label: 'Cuisines', icon: 'fas fa-globe-europe', route: '/restaurant/menu-setup/cuisine' },
        { label: 'Courses', icon: 'fas fa-layer-group', route: '/restaurant/menu-setup/course' },
        { label: 'Categories', icon: 'fas fa-tags', route: '/restaurant/menu-setup/category' },
        { label: 'Dish Groups', icon: 'fas fa-object-group', route: '/restaurant/menu-setup/grp-dish' },
        { label: 'Dishes', icon: 'fas fa-drumstick-bite', route: '/restaurant/menu-setup/dish' },
        { label: 'Pizza Menu', icon: 'fas fa-circle', route: '/restaurant/menu-setup/pizza-dish/entry' },
        { label: '\u00c0 La Carte', icon: 'far fa-file-alt', route: '/restaurant/menu-setup/ala-carta' },
        { label: 'Copy Menu', icon: 'far fa-copy', route: '/restaurant/menu-setup/duplicate-menu' }
      ]
    },
    {
      label: 'Deals & Rewards', icon: 'fas fa-gift', id: 'res-promotions',
      children: [
        { label: 'Loyalty Points', icon: 'fas fa-star', route: '/restaurant/management/loyalty-points' },
        { label: 'Vouchers', icon: 'fas fa-ticket-alt', route: '/restaurant/management/vouchers' },
        { label: 'Promotions & Deals', icon: 'fas fa-percentage', route: '/restaurant/management/promotions-and-deals' },
        { label: 'Booking Deals', icon: 'fas fa-calendar-check', route: '/restaurant/management/booking-deals' },
        { label: 'Coupons', icon: 'fas fa-cut', route: '/restaurant/management/coupon' },
        { label: 'Service Charges', icon: 'fas fa-sliders-h', route: '/restaurant/management/service-config' }
      ]
    },
    { label: 'Customers', icon: 'fas fa-user-friends', route: '/restaurant/customers' },
    { label: 'Drivers', icon: 'fas fa-biking', route: '/restaurant/driver-management' },
    {
      label: 'Settings', icon: 'fas fa-cog', id: 'res-settings',
      children: [
        { label: 'Basic Info', icon: 'fas fa-info-circle', route: '/restaurant/setting/primary-configurations' },
        { label: 'Opening Hours', icon: 'far fa-clock', route: '/restaurant/setting/schedule' },
        { label: 'Advanced Schedule', icon: 'fas fa-calendar-week', route: '/restaurant/setting/new-schedule' },
        { label: 'Delivery Zones', icon: 'fas fa-map-marked-alt', route: '/restaurant/setting/delivery-zone' },
        { label: 'Booking Settings', icon: 'far fa-calendar-alt', route: '/restaurant/setting/booking-setting' },
        { label: 'Printer Settings', icon: 'fas fa-print', route: '/restaurant/setting/printer-setting' }
      ]
    },
    {
      label: 'Website', icon: 'fas fa-globe', id: 'res-website',
      children: [
        { label: 'Content (CMS)', icon: 'far fa-file-word', route: '/restaurant/setting/cms' },
        { label: 'Custom Page', icon: 'far fa-newspaper', route: '/restaurant/setting/custom-pages' },
        { label: 'SEO', icon: 'fas fa-search', route: '/restaurant/setting/seo' },
        { label: 'Custom CSS', icon: 'fas fa-code', route: '/restaurant/setting/custom-css' },
        { label: 'Events', icon: 'far fa-calendar', route: '/restaurant/management/event-management' },
        { label: 'Blog Posts', icon: 'fas fa-blog', route: '/restaurant/management/blog-management' }
      ]
    },
    {
      label: 'Integrations', icon: 'fas fa-plug', id: 'res-integrations',
      children: [
        { label: 'Payment Settings', icon: 'fas fa-money-check', route: '/restaurant/integration/payment-integration' },
        { label: 'Delivery Platforms', icon: 'fas fa-truck', route: '/restaurant/integration/delivery-platform-integration' },
        { label: 'Just Eat DaaS', icon: 'fas fa-motorcycle', route: '/restaurant/integration/just-eat-daas' },
        { label: 'Booking Platforms', icon: 'fas fa-calendar-alt', route: '/restaurant/integration/booking-platform-integration' },
        { label: 'Social Media', icon: 'fas fa-share-alt', route: '/restaurant/integration/social-media' }
      ]
    },
    { label: 'Staff Accounts', icon: 'fas fa-users-cog', route: '/restaurant/system-user' },
    { label: 'App Versions', icon: 'fas fa-code-branch', route: '/restaurant/app-version-control' }
  ];

  constructor(
    public shared: SharedService,
    private restService: RestaurantService,
    private authService: AuthenticationService,
    private router: Router
  ) {
    this.restaurant = JSON.parse(sessionStorage.getItem('restaurant_data') || '{}');
    console.log(this.restaurant);
    this.restaurant_id = sessionStorage.getItem('restaurant_id');
    console.log(this.restaurant_id);
    this.user = this.authService.getDecodedUser();
  }

  ngOnInit() {
    this.tamplate_setting = JSON.parse(localStorage.getItem('tamplate_setting') || '{}');
    this.shared.totalOrders.subscribe((item: any) => {
      this.totalOrders = item;
    });
    this.syncOpenGroups();
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
      this.syncOpenGroups();
    });
  }

  toggleGroup(id: string | undefined, navItems: NavItem[], event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!id) {
      return;
    }

    const shouldOpen = !this.openGroups[id];
    this.closeGroups(navItems);
    this.openGroups[id] = shouldOpen;
  }

  isGroupOpen(id: string): boolean {
    return !!this.openGroups[id];
  }

  isGroupActive(items: NavItem[]): boolean {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.route && this.router.isActive(item.route, false)) {
        return true;
      }
      if (item.children && this.isGroupActive(item.children)) {
        return true;
      }
    }
    return false;
  }

  private syncOpenGroups() {
    this.closeGroups(this.adminNavItems);
    this.closeGroups(this.restaurantNavItems);

    this.openActiveGroup(this.adminNavItems);
    this.openActiveGroup(this.restaurantNavItems);
  }

  private closeGroups(navItems: NavItem[]) {
    for (let i = 0; i < navItems.length; i++) {
      const item = navItems[i];
      if (item.children && item.id) {
        this.openGroups[item.id] = false;
      }
    }
  }

  private openActiveGroup(navItems: NavItem[]) {
    for (let i = 0; i < navItems.length; i++) {
      const item = navItems[i];
      if (item.children && item.id && this.isGroupActive(item.children)) {
        this.openGroups[item.id] = true;
        break;
      }
    }
  }

  syncRestaurant() {
    this.shared.loadingStart();
    this.restService.resDataSyncByResId(this.restaurant_id).subscribe(res => {
      this.shared.loadingClose();
    }, err => {
      this.shared.loadingClose();
    });
  }

  goToWebLink(data: any) {
    var url = String(data).replace(/^(https?:\/\/)?(www\.)?/, 'http://');
    window.open(url, '_blank');
  }
}
